import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Prodotti from "./pages/Prodotti";
import Formule from "./pages/Formule";
import Produzione from "./pages/Produzione";
import Scanner from "./pages/Scanner";
import Movimenti from "./pages/Movimenti";
import Etichette from "./pages/Etichette";
import Ordini from "./pages/Ordini";
import Conversioni from "./pages/Conversioni";
import Listino from "./pages/Listino";
import Lavorazione from "./pages/Lavorazione";
import Plastiche from "./pages/Plastiche";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/prodotti" element={<Prodotti />} />
              <Route path="/formule" element={<Formule />} />
              <Route path="/produzione" element={<Produzione />} />
              <Route path="/scanner" element={<Scanner />} />
              <Route path="/movimenti" element={<Movimenti />} />
              <Route path="/etichette" element={<Etichette />} />
              <Route path="/ordini" element={<Ordini />} />
              <Route path="/conversioni" element={<Conversioni />} />
              <Route path="/listino" element={<Listino />} />
              <Route path="/lavorazione/:orderId" element={<Lavorazione />} />
              <Route path="/plastiche" element={<Plastiche />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
